import React, { useState } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { ButtonBase, TextField } from '@material-ui/core'
import cx from 'classnames'
import EditIcon from '@material-ui/icons/Edit'

const useStyles = makeStyles(theme => ({
  button: {
    font: 'inherit',
    letterSpacing: 'inherit',
    maxWidth: '100%',
    overflow: 'hidden',

    '& > span': {
      display: 'inline-block',
      maxWidth: '100%',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },

    '&:hover': {
      textDecoration: 'underline',
      color: theme.palette.primary.main,
    }
  },
  empty: {
    color: theme.palette.grey['400'],
    '&:hover': {
      color: theme.palette.grey['700'],
    }
  },
  field: {
    width: '100%',
    fontSize: 'inherit',
    textAlign: 'inherit',
    '& .MuiInputBase-formControl': {
      fontSize: 'inherit',
    },
    '& input': {
      fontSize: '1em',
      textAlign: 'inherit'
    }
  },
  editIcon: {
    marginLeft: '.5em',
    fontSize: '1em',
  }
}));

type InlineEditableProps = {
  text: string,
  onSave: (value: string) => void
}

export const InlineEditable: React.FC<InlineEditableProps> = ({ text, onSave }) => {
  const classes = useStyles();
  const [editing, setEditing] = useState(false);
  const [value, setValue] = useState(text);

  const onBlur = () => {
    setEditing(false);
    onSave(value);
  }

  const onKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
    if (event.key === 'Enter') {
      onBlur();
    } else if (event.key === 'Escape') {
      setValue(text);
      setEditing(false)
    }
  }

  return editing ? (
    <TextField
      autoFocus
      className={classes.field}
      onBlur={onBlur}
      onChange={(e) => setValue(e.target.value)}
      onKeyDown={onKeyDown}
      value={value}
      inputProps={{ component: 'span' }}
    />
  ) : (
    <ButtonBase
      className={cx(classes.button, { [classes.empty]: !text })}
      onClick={() => setEditing(true)}
    >
      <span>
        {text || '(unnamed room)'}
      </span>
      <EditIcon className={classes.editIcon} />
    </ButtonBase>
  );
};
